import { Facebook, Instagram, List, LogOut, Send, User } from "lucide-react";
const shadeLinks = [
	{
		text: "All Shades",
		to: "/shop",
	},
	{
		text: "Roller Shades",
		to: "/shop/info/roller",
	},
	{
		text: "Zebra Shades",
		to: "/shop/info/zebra",
	},
	{
		text: "Sheer Shades",
		to: "/shop/info/sheer",
	},
	{
		text: "Cellular Shades",
		to: "/shop/info/cellular",
	},

	{
		text: "Motorization",
		to: "/motorized-solutions",
	},
];

const fabricLinks = [
	{
		text: "Blackout",
		to: "blackout",
	},
	{
		text: "Privacy",
		to: "privacy",
	},
	{
		text: "Translucent",
		to: "translucent",
	},
	{
		text: "Sunscreen",
		to: "sunscreen",
	},
	{
		text: "Transparent",
		to: "transparent",
	},
];

const optionLinks = [
	{
		text: "Control Options",
		to: "control-options",
	},
	{
		text: "Valance Options",
		to: "valance-options",
	},
	{
		text: "Bottom Bar Options",
		to: "bottombar-options",
	},
	{
		text: "Fabric Options",
		to: "fabric-options",
	},
];

const helpLinks = [
	{
		text: "Blog",
		to: "/guides/blog",
		className: "mainFont",
	},
	{
		text: "Measuring Guide",
		to: "/guides/measuring-guide",
		className: "mainFont",
	},
	{
		text: "Installation Guide",
		to: "/guides/installation-guide",
		className: "mainFont",
	},
	{
		text: "Privacy Policy",
		to: "/guides/privacy-policy",
		className: "mainFont",
	},
	{
		text: "Shipping Policy",
		to: "/guides/shipping-policy",
		className: "mainFont",
	},
	{
		text: "Guarantee",
		to: "/guides/return-policy",
		className: "mainFont",
	},
	{
		text: "Terms & Conditions",
		to: "/guides/terms-conditions",
		className: "mainFont",
	},
	{
		text: "Warranty",
		to: "/guides/warranty",
		className: "mainFont",
	},
];

const aboutLinks = [
	{
		text: "About Us",
		to: "/about",
	},

	{
		text: "Contact Us",
		to: "/contact",
	},
];

const contactLinks = [
	{
		text: "50 Hollinger Road, Toronto, ON M4B 3G5",
		to: "https://goo.gl/maps/36U4aPh4ibbB1Ck27",
	},
	{ text: "info@offcutshades.com", to: "/contact" },
	{ text: "(416) 285-6001", to: "tel:+14162856001" },
];

const socialLinks = [
	{
		text: "Facebook",
		to: "https://www.facebook.com/OffCutShadesOnline/",
		Icon: Facebook,
	},
	{
		text: "Instagram",
		to: "https://www.instagram.com/offcutshades/",
		Icon: Instagram,
	},
];

const pageLinks = [
	{ text: "SHOP", to: "/shop" },
	{
		text: "WINDOW SHADES",
		//put all shades here
		to: "/shop",
		subMenu: [
			...shadeLinks.map((item) => ({
				...item,
				text: `${item.text}`,
				to: `${item.to}`,
			})),
		],
	},
	{ text: "FREE CONSULTATION", to: "/special-offer" },
	{ text: "DESIGN GUIDE", to: "/design-guide" },
	{ text: "ABOUT", to: "/about" },
	{ text: "GUIDES", to: "/guides", subMenu: helpLinks },
	{ text: "CONTACT US", to: "/contact" },
];

const infoLinks = [];
const accountLinks = (logoutHandler = () => {}) => [
	{ text: "Profile", to: "/profile", icon: <User /> },
	{
		text: "Refer a Friend",
		to: "/profile",
		icon: <Send />,
	},
	{
		text: "Orders",
		to: "/myorders",
		icon: <List />,
	},
	{ text: "Logout", onClick: logoutHandler, icon: <LogOut /> },
];

const windowShades = [
	{
		text: "Living Room Shades",
		to: "/shop/living-room-window-shades",
		className: "mainFont",
	},
	{
		text: "Bedroom Shades",
		to: "/shop/bedroom-window-shades",
		className: "mainFont",
	},
	{
		text: "Commercial Shades",
		to: "/shop/commercial-window-shades",
		className: "mainFont",
	},
	{
		text: "Dining Room Shades",
		to: "/shop/dining-room-window-shades",
		className: "mainFont",
	},
	{
		text: "Home Theatre Shades",
		to: "/shop/home-theatre-window-shades",
		className: "mainFont",
	},
	{
		text: "Kitchen Shades",
		to: "/shop/kitchen-window-shades",
		className: "mainFont",
	},
	{
		text: "Residential Shades",
		to: "/shop/residential-window-shades",
		className: "mainFont",
	},
	{
		text: "Skylight Roller Shades",
		to: "/shop/skylight-roller-shades",
		className: "mainFont",
	},
	{
		text: "Graphic Shades",
		to: "/shop/graphic-shades",
		className: "mainFont",
	},
];

export {
	shadeLinks,
	fabricLinks,
	optionLinks,
	helpLinks,
	aboutLinks,
	contactLinks,
	socialLinks,
	pageLinks,
	infoLinks,
	accountLinks,
	windowShades,
};
